// ─────────────────────────────────────────────────────────────────────────
// FALLBACK / SEED expression data — hand-curated stubs.
//
// These are the original 8 Eddie-approved coverage records (chosen to force
// every visual branch). They are the seed/fallback used until the live
// Airtable sync has populated `expressions.generated.json`. Once the synced
// path is proven, this file can be retired.
//
// Identity: each carries a stable string `uid` (mirrors Airtable's UniqueID
// autonumber) so per-user state keys on `uid`, never on the English text.
// `recordId` is null here (no Airtable record id for hand-curated seeds).
//
// fit_* ∈ '자연스러워요' | '무난해요' | '어색해요' (byte-exact)
// awkward pair 2 + example pair 2 are optional; null = render nothing.
// ─────────────────────────────────────────────────────────────────────────
export const FALLBACK_EXPRESSIONS = [
  {
    uid: '1',
    recordId: null,
    expression_en: 'wanted to flag ~',
    meaning_ko: '~를 짚고 넘어가고 싶었습니다',
    fit_email: '자연스러워요',
    fit_message: '자연스러워요',
    fit_meeting: '자연스러워요',
    fit_presentation: '무난해요',
    fit_smalltalk: '어색해요',
    when_to_use_ko: '문제나 리스크를 정중하게 미리 알릴 때 써요.',
    awkward_en_1: 'I want to tell you in advance.',
    awkward_why_ko_1: "'미리 말씀드리다'를 tell in advance로 옮겨, 가볍게 환기하는 뉘앙스가 사라집니다.",
    awkward_en_2: 'I would like to warn you about ~.',
    awkward_why_ko_2: 'warn은 경고처럼 무겁고 위협적으로 들립니다.',
    example_en: 'I wanted to flag a potential risk with the timeline.',
    example_ko: '일정에 잠재적 리스크가 있어 미리 말씀드리고 싶었어요.',
    example_en_2: null,
    example_ko_2: null,
  },
  {
    uid: '2',
    recordId: null,
    expression_en: 'set up time',
    meaning_ko: '시간을 잡다',
    fit_email: '자연스러워요',
    fit_message: '자연스러워요',
    fit_meeting: '자연스러워요',
    fit_presentation: '무난해요',
    fit_smalltalk: '무난해요',
    when_to_use_ko: '미팅이나 통화 일정을 잡을 때 써요.',
    awkward_en_1: 'make time',
    awkward_why_ko_1: "'시간을 만들다'를 그대로 옮겨, 일정을 잡는다는 뜻보다 짬을 낸다는 뜻으로 읽힙니다.",
    awkward_en_2: 'arrange an appointment',
    awkward_why_ko_2: 'appointment는 병원 예약처럼 무겁게 들립니다.',
    example_en: "Let's set up time to go over the deck.",
    example_ko: '자료 같이 볼 시간을 잡으시죠.',
    example_en_2: null,
    example_ko_2: null,
  },
  {
    uid: '3',
    recordId: null,
    expression_en: 'have a conflict',
    meaning_ko: '일정이 겹치다',
    fit_email: '자연스러워요',
    fit_message: '자연스러워요',
    fit_meeting: '자연스러워요',
    fit_presentation: '무난해요',
    fit_smalltalk: '무난해요',
    when_to_use_ko: '제안된 시간에 다른 일정이 있을 때 써요.',
    awkward_en_1: 'My schedule is overlapped.',
    awkward_why_ko_1: "'일정이 겹치다'를 overlapped로 옮겨, 영어에서는 잘 쓰지 않는 표현입니다.",
    awkward_en_2: 'I have a scheduling collision.',
    awkward_why_ko_2: 'collision은 충돌이라는 단어가 과하게 강합니다.',
    example_en: 'I have a conflict at 3 — could we do 4?',
    example_ko: '3시엔 일정이 겹쳐서요, 4시 가능할까요?',
    example_en_2: null,
    example_ko_2: null,
  },
  {
    uid: '4',
    recordId: null,
    expression_en: 'wanted to touch base',
    meaning_ko: '한번 확인드리고 싶었습니다',
    fit_email: '자연스러워요',
    fit_message: '자연스러워요',
    fit_meeting: '무난해요',
    fit_presentation: '어색해요',
    fit_smalltalk: '무난해요',
    when_to_use_ko: '가볍게 진행 상황을 확인할 때 써요.',
    awkward_en_1: 'I wanted to contact you once.',
    awkward_why_ko_1: "'한번 연락드리다'의 '한번'을 once로 옮겨, 단발성 통보처럼 들립니다.",
    awkward_en_2: 'I wanted to communicate with you.',
    awkward_why_ko_2: 'communicate는 사무적이고 거리감 있게 들립니다.',
    example_en: 'Just wanted to touch base on the timeline.',
    example_ko: '일정 관련해서 한번 확인드리고 싶었어요.',
    example_en_2: null,
    example_ko_2: null,
  },
  {
    uid: '5',
    recordId: null,
    expression_en: 'off the cuff',
    meaning_ko: '즉석에서, 준비 없이',
    fit_email: '어색해요',
    fit_message: '무난해요',
    fit_meeting: '자연스러워요',
    fit_presentation: '어색해요',
    fit_smalltalk: '무난해요',
    when_to_use_ko: '준비 없이 즉석에서 의견을 말할 때 써요.',
    awkward_en_1: 'without preparation',
    awkward_why_ko_1: "'준비 없이'를 그대로 옮겨, 자연스러운 관용 표현이 되지 못합니다.",
    awkward_en_2: 'in an impromptu way',
    awkward_why_ko_2: 'impromptu는 사전에서 골라, 말로는 딱딱하게 들립니다.',
    example_en: "Off the cuff, I'd say about six months.",
    example_ko: '즉석에서 말씀드리면 한 6개월쯤 걸릴 것 같아요.',
    example_en_2: null,
    example_ko_2: null,
  },
  {
    uid: '6',
    recordId: null,
    expression_en: 'kill time',
    meaning_ko: '시간을 때우다',
    fit_email: '어색해요',
    fit_message: '무난해요',
    fit_meeting: '무난해요',
    fit_presentation: '어색해요',
    fit_smalltalk: '자연스러워요',
    when_to_use_ko: '가볍게 시간을 보낸다는 걸 말할 때 써요.',
    awkward_en_1: 'spend time uselessly',
    awkward_why_ko_1: "'시간을 때우다'를 풀어 옮겨, 부정적이고 어색하게 들립니다.",
    awkward_en_2: 'pass the time meaninglessly',
    awkward_why_ko_2: 'meaninglessly는 사전에서 골라, 무겁고 부자연스럽습니다.',
    example_en: 'We had an hour to kill before the next session.',
    example_ko: '다음 세션 전에 한 시간 정도 때울 시간이 있었어요.',
    example_en_2: null,
    example_ko_2: null,
  },
  {
    uid: '7',
    recordId: null,
    expression_en: 'Please share ~',
    meaning_ko: '~를 공유해 주세요',
    fit_email: '자연스러워요',
    fit_message: '무난해요',
    fit_meeting: '무난해요',
    fit_presentation: '무난해요',
    fit_smalltalk: '어색해요',
    when_to_use_ko: '필요한 자료나 정보를 정중히 요청할 때 써요.',
    awkward_en_1: 'Give me ~.',
    awkward_why_ko_1: "'주세요'를 give me로 옮겨, 명령처럼 들려 무례하게 느껴집니다.",
    awkward_en_2: 'Kindly provide me ~.',
    awkward_why_ko_2: 'kindly provide는 과하게 격식적이라 오히려 사무적입니다.',
    example_en: 'Please share the latest numbers when you get a chance.',
    example_ko: '시간 되실 때 최신 수치 공유해 주세요.',
    example_en_2: null,
    example_ko_2: null,
  },
  {
    uid: '8',
    recordId: null,
    expression_en: 'find time',
    meaning_ko: '시간을 내다',
    fit_email: '자연스러워요',
    fit_message: '자연스러워요',
    fit_meeting: '자연스러워요',
    fit_presentation: '무난해요',
    fit_smalltalk: '무난해요',
    when_to_use_ko: '바쁜 중에 짬을 내 일정을 잡을 때 써요.',
    awkward_en_1: 'search time',
    awkward_why_ko_1: "'시간을 찾다'의 '찾다'를 search로 옮겨, 영어로는 어색합니다.",
    awkward_en_2: null,
    awkward_why_ko_2: null,
    example_en: 'Can we find time this week to sync?',
    example_ko: '이번 주에 짬 내서 한번 맞춰볼 수 있을까요?',
    example_en_2: null,
    example_ko_2: null,
  },
];
